/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPointsHistoryRespVo
 */
export interface UserPointsHistoryRespVo {
    /**
     * 积分历史记录 ID
     * @type {number}
     * @memberof UserPointsHistoryRespVo
     */
    id?: number;
    /**
     * 用户积分数据 ID
     * @type {number}
     * @memberof UserPointsHistoryRespVo
     */
    pointsId?: number;
    /**
     * 本次变动积分数
     * @type {number}
     * @memberof UserPointsHistoryRespVo
     */
    amount?: number;
    /**
     * 变动后的积分余额
     * @type {number}
     * @memberof UserPointsHistoryRespVo
     */
    principal?: number;
    /**
     * 出入类型：0-出积分，1-入积分
     * @type {number}
     * @memberof UserPointsHistoryRespVo
     */
    intOutType?: number;
    /**
     * 备注说明
     * @type {string}
     * @memberof UserPointsHistoryRespVo
     */
    remark?: string;
    /**
     * 用户 ID
     * @type {number}
     * @memberof UserPointsHistoryRespVo
     */
    userId?: number;
    /**
     * 用户账号
     * @type {string}
     * @memberof UserPointsHistoryRespVo
     */
    account?: string;
    /**
     * 用户名
     * @type {string}
     * @memberof UserPointsHistoryRespVo
     */
    name?: string;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof UserPointsHistoryRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof UserPointsHistoryRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof UserPointsHistoryRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the UserPointsHistoryRespVo interface.
 */
export function instanceOfUserPointsHistoryRespVo(value: object): value is UserPointsHistoryRespVo {
    return true;
}

export function UserPointsHistoryRespVoFromJSON(json: any): UserPointsHistoryRespVo {
    return UserPointsHistoryRespVoFromJSONTyped(json, false);
}

export function UserPointsHistoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPointsHistoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'pointsId': json['pointsId'] == null ? undefined : json['pointsId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'principal': json['principal'] == null ? undefined : json['principal'],
        'intOutType': json['intOutType'] == null ? undefined : json['intOutType'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'account': json['account'] == null ? undefined : json['account'],
        'name': json['name'] == null ? undefined : json['name'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function UserPointsHistoryRespVoToJSON(json: any): UserPointsHistoryRespVo {
    return UserPointsHistoryRespVoToJSONTyped(json, false);
}

export function UserPointsHistoryRespVoToJSONTyped(value?: UserPointsHistoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'pointsId': value['pointsId'],
        'amount': value['amount'],
        'principal': value['principal'],
        'intOutType': value['intOutType'],
        'remark': value['remark'],
        'userId': value['userId'],
        'account': value['account'],
        'name': value['name'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

